// import React, { Component } from 'react';
// import sectiondata from '../../data/sections.json';
// import parse from 'html-react-parser';
// import footerdata from '../../data/footerdata.json';
// import blogdata from "../../JsonData/blogdata.json";
// class Faqs extends Component {


//   render() {

//     let publicUrl = process.env.PUBLIC_URL + '/'
//     let imagealt = 'image'
//     let data = sectiondata.faq


//     return <div className="faq-area pd-top-65 pd-bottom-100">
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-6 mb-5 mb-lg-0">
//             <div className="section-title">
//               <h2 className="title" dangerouslySetInnerHTML={{ __html: data.title }}></h2>
//               <p>{data.content}</p>
//             </div>
//             <div className="accordion" id="accordion">
//               {/* single accordion */}
//               {data.items.map((item, i) =>
//                 <div key={i} className="single-accordion card">
//                   <div className="card-header" id={"headingOne" + i}>
//                     <h2 className="mb-0">
//                       <button className="btn-link" type="button" data-toggle="collapse" data-target={"#collapseOne" + i} aria-expanded="true" aria-controls={"collapseOne" + i}>{item.title}</button>
//                     </h2>
//                   </div>
//                   <div id={"collapseOne" + i} className={"collapse " + item.class} aria-labelledby={"headingOne" + i} data-parent="#accordion">
//                     <div className="card-body">
//                       {item.content}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//           <div className="col-xl-5 col-lg-6 offset-xl-1">
//             <div className="shape-image-list-wrap">
//               <div className="shape-image-list left-top">
//                 <img src={publicUrl + data.image} alt={imagealt} />
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Share Section */}

//         <div className="mt-4">
//           <p className="fw-semibold"><strong>Share:</strong></p>

//           <ul className="social-icon d-flex align-items-center gap-3 list-unstyled p-0 m-0">
//             <li>
//               <a href="https://www.facebook.com/profile.php?id=61574452610932" target="_blank" rel="noopener noreferrer">
//                 <i className="fa fa-facebook" />
//               </a>
//             </li>
//             <li>
//               <a href="https://x.com/TrinestSky?t=0nIVrZfREEaavLFy1dJrQQ&s=09" target="_blank" rel="noopener noreferrer">
//                 <img src='/icons8-x-50.png' style={{ width: "15px", marginTop: "-5px" }} alt="X Logo" />
//               </a>
//             </li>
//             <li>
//               <a href="https://www.linkedin.com/company/trinest-sky-real-estate/" target="_blank" rel="noopener noreferrer">
//                 <i className="fa fa-linkedin" />
//               </a>
//             </li>
//             <li>
//               <a href="https://www.instagram.com/trinestsky/" target="_blank" rel="noopener noreferrer">
//                 <i className="fa fa-instagram" />
//               </a>
//             </li>
//             <li>
//               <a href="https://www.youtube.com/channel/UCKrImHaqk4uHfAsHt9Ak4kg" target="_blank" rel="noopener noreferrer">
//                 <i className="fa-brands fa-youtube"></i>
//               </a>
//             </li>
//             <li>
//               <a href="https://www.tiktok.com/@trinestsky?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer">
//                 <i className="fa-brands fa-tiktok"></i>
//               </a>
//             </li>
//           </ul>
//         </div>

//       </div>

//     </div>
//   }
// }

// export default Faqs

import React, { useState } from 'react';
import sectiondata from '../../data/sections.json';

const Faqs = () => {
  const [isHovered, setIsHovered] = useState(false);
  let publicUrl = process.env.PUBLIC_URL + '/';
  let imagealt = 'image';
  let data = sectiondata.faq;

  return (
    <div className="faq-area pd-top-65 pd-bottom-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mb-5 mb-lg-0">
            <div className="section-title">
              <h2
                className="title"
                dangerouslySetInnerHTML={{ __html: data.title }}
              ></h2>
              <p>{data.content}</p>
            </div>
            <div className="accordion" id="accordion">
              {data.items.map((item, i) => (
                <div key={i} className="single-accordion card">
                  <div className="card-header" id={`headingOne${i}`}>
                    <h2 className="mb-0">
                      <button
                        className="btn-link"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapseOne${i}`}
                        aria-expanded="true"
                        aria-controls={`collapseOne${i}`}
                      >
                        {item.title}
                      </button>
                    </h2>
                  </div>
                  <div
                    id={`collapseOne${i}`}
                    className={`collapse ${item.class}`}
                    aria-labelledby={`headingOne${i}`}
                    data-parent="#accordion"
                  >
                    <div className="card-body">{item.content}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-xl-5 col-lg-6 offset-xl-1">
            <div className="shape-image-list-wrap">
              <div className="shape-image-list left-top">
                <img src={publicUrl + data.image} alt={imagealt} />
              </div>
            </div>
          </div>
        </div>

        {/* Share Section */}
        <div className="mt-4">
          <p className="fw-semibold">
            <strong>Share:</strong>
          </p>
          <ul className="social-icon d-flex align-items-center gap-3 list-unstyled p-0 m-0">
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61574452610932"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-facebook" />
              </a>
            </li>
            <li>
              <a
                href="https://x.com/TrinestSky?t=0nIVrZfREEaavLFy1dJrQQ&s=09"
                target="_blank"
                rel="noopener noreferrer"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <img
                  src={
                    isHovered
                      ? '/twitterWhite.png'
                      : '/icons8-x-50.png'
                  }
                  style={{ width: '15px', marginTop: '-5px' }}
                  alt="X Logo"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/trinest-sky-real-estate/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-linkedin" />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/trinestsky/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-instagram" />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UCKrImHaqk4uHfAsHt9Ak4kg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-youtube" />
              </a>
            </li>
            <li>
              <a
                href="https://www.tiktok.com/@trinestsky?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-tiktok" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
